import { render, staticRenderFns } from "./FFSkeleton.vue?vue&type=template&id=281aeb69&scoped=true&"
import script from "./FFSkeleton.vue?vue&type=script&lang=js&"
export * from "./FFSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./FFSkeleton.vue?vue&type=style&index=0&id=281aeb69&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281aeb69",
  null
  
)

export default component.exports